var _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgAdvantagesUser = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.3518 38.8203C8.6911 38.8333 -0.222942 30.0448 0.00425893 18.9797C0.219627 8.49563 8.84613 -0.155341 19.6795 0.00235963C30.1864 0.155318 38.8969 8.81222 38.7324 19.7232C38.5726 30.3602 29.8846 38.8416 19.3518 38.8203ZM5.74698 19.3769C5.73396 26.854 11.8968 33.0802 19.3565 33.0399C26.8221 32.9984 32.9648 27.071 32.9423 19.3722C32.9187 11.5939 26.705 5.83014 19.4109 5.77204C11.9358 5.71394 5.75999 11.8951 5.74698 19.3769Z",
    fill: "url(#paint0_linear_7008_14133)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.4067 14.9453L17.8277 24.9453L13.4067 21.0564",
    stroke: "#1E7EB7",
    strokeWidth: 2
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_7008_14133",
    x1: 83.4921,
    y1: -50.3194,
    x2: -4.38855,
    y2: -45.9657,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#221C3E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#208AC6"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgAdvantagesUser);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/AdvantagesUser.9a54707064426f3491455e426287b703.svg";